import { type Place } from '@/features/place/types/place-types';
import convertCoordinatesToBbox from '@/features/place/utils/convert-coordinates-to-bbox';
import { type FeatureResponse } from '@/libs/geocode-earth/geocode-earth-types';

export default function placeAdapter(feature: FeatureResponse): Place {
  // Geocoder occasionally returns a point bbox (SW == NE); the search API 500s on zero-area bbox.
  const hasValidBbox = feature.bbox &&
    (feature.bbox[0] !== feature.bbox[2] || feature.bbox[1] !== feature.bbox[3]);

  const bbox: Place['bbox'] = hasValidBbox
    ? {
      longitudeSouthWest: feature.bbox![0],
      latitudeSouthWest: feature.bbox![1],
      longitudeNorthEast: feature.bbox![2],
      latitudeNorthEast: feature.bbox![3],
    }
    : convertCoordinatesToBbox({
      longitude: feature.geometry.coordinates[0],
      latitude: feature.geometry.coordinates[1],
    });

  return {
    fullName: feature.properties.label,
    bbox,
    geometry: {
      coordinates: {
        longitude: feature.geometry.coordinates[0],
        latitude: feature.geometry.coordinates[1],
      },
    },
  };
}
